import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Tarifs from './components/Tarifs';
import Marches from './components/Marches';
import QRCodeSection from './components/QRCodeSection';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Services />
        <Gallery />
        <Tarifs />
        <Marches />
        <QRCodeSection />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
